import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const CircleBar = ({ percentage, amount, size = 1 }) => {
    //https://jakearchibald.com/2013/animated-line-drawing-svg/
    const width = 50 * size;
    const stroke = 6 * size;
    const fontSize = 1.5 * size;
    const total = 132 * size;
    const offset = Math.round(total - (percentage * total) / 100);
    const radius = (width - stroke) / 2;
    const circleX = width / 2;
    const circleY = width / 2;
    return _jsxs("svg", { className: "circle-bar circle-bar--bottom-left", height: width, width: width, children: [_jsx("circle", { className: "circle-bar__bg", strokeWidth: stroke, r: radius, cx: circleX, cy: circleY }), percentage ? (_jsx("circle", { className: "circle-bar__progress", strokeWidth: stroke, strokeDashoffset: offset, strokeDasharray: total + ',' + total, r: radius, cx: circleX, cy: circleY })) : null, _jsx("foreignObject", { height: "100%", width: "100%", children: _jsx("div", { className: "circle-bar__amount", style: {
                        fontSize: fontSize + 'rem',
                    }, children: amount }) })] });
};
export default CircleBar;
